var text_field_default = {
  "root": "waHbC",
  "text": "DAcJp",
  "input": "iZkni",
  "small": "yMDe7",
  "medium": "pHhlw",
  "large": "kpgEG",
  "webview": "spaL9",
  "endAdornment": "cvvRl",
  "shown": "dApq1",
  "value": "PUnV1",
  "spinner": "KzlRn",
  "spin": "ichwN"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
